import { Button, Card, Dropdown } from "react-bootstrap";
import { BsDownload, BsFunnel } from "react-icons/bs";
import { CiImport, CiSearch } from "react-icons/ci";
import { HiOutlineDotsCircleHorizontal } from "react-icons/hi";

const BillingSubscription = () => {
    return ( <>
    <div className="container-fluid py-3">
        <Card body>
            <div className="hstack gap-2">
                <span className="fs-6 fw-semibold">Billing</span>
                <div className="hstack gap-2 ms-auto">
                    <div className="col-12 col-md-4 col-xl-auto">
                        <div className="search-box border rounded-2">
                            <label htmlFor="invoiceSearch" className="searchbutton fs-16" type="button">
                                <CiSearch />
                            </label>
                            <input type="search" id="invoiceSearch" placeholder="Search Invoices"
                            className="searchfield bg-body-tertiary rounded-2" />
                        </div>
                    </div>
                    <Button variant="light"><BsFunnel size={16} className="me-2" /><span>Filters</span></Button>
                    <Button variant="dark"><BsDownload size={16} className="me-2" /><span>Export</span></Button>
                </div>
            </div>
            <div className="tbl-container rounded-table rounded-2 mt-2">
                <div className="table-responsive overflow-y-auto" style={{maxHeight: 'calc(100vh - 160px)'}}>
                    <table className="table mb-0">
                        <thead className="table-header table-light">
                            <tr>
                                <th style={{ minWidth: '30px' }}>
                                    <input name="invoice-headerCheck" className="form-check-input cursor-pointer" type="checkbox" />
                                </th>
                                <th>INVOICES</th>
                                <th>DATE</th>
                                <th>AMOUNT</th>
                                <th>STATUS</th>
                                <th>PLAN</th>
                                <th className="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ minWidth: '30px' }}>
                                    <input name="invoice-check-1" className="form-check-input cursor-pointer" type="checkbox" />
                                </td>
                                <td>INV-2023-001</td>
                                <td>15-01-2023</td>
                                <td>$ 450.00</td>
                                <td><span className="badge badge-light-success">Paid</span></td>
                                <td>Pro</td>
                                <td>
                                    <div className="hstack gap-2 justify-content-center">
                                        <Button variant="light" className="p-1 rounded-circle">
                                            <CiImport size={16} />
                                        </Button>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="light"
                                            className="p-1 rounded-circle without-arrow">
                                                <HiOutlineDotsCircleHorizontal size={20} />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item as="button">Option 1</Dropdown.Item>
                                                <Dropdown.Item as="button">Option 2</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ minWidth: '30px' }}>
                                    <input name="invoice-check-2" className="form-check-input cursor-pointer" type="checkbox" />
                                </td>
                                <td>INV-2023-001</td>
                                <td>15-01-2023</td>
                                <td>$ 450.00</td>
                                <td><span className="badge badge-light-warning">Pending</span></td>
                                <td>Premium</td>
                                <td>
                                    <div className="hstack gap-2 justify-content-center">
                                        <Button variant="light" className="p-1 rounded-circle">
                                            <CiImport size={16} />
                                        </Button>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="light"
                                            className="p-1 rounded-circle without-arrow">
                                                <HiOutlineDotsCircleHorizontal size={20} />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item as="button">Option 1</Dropdown.Item>
                                                <Dropdown.Item as="button">Option 2</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ minWidth: '30px' }}>
                                    <input name="invoice-check-2" className="form-check-input cursor-pointer" type="checkbox" />
                                </td>
                                <td>INV-2023-001</td>
                                <td>15-01-2023</td>
                                <td>$ 450.00</td>
                                <td><span className="badge badge-light-danger">Failed</span></td>
                                <td>Pro</td>
                                <td>
                                    <div className="hstack gap-2 justify-content-center">
                                        <Button variant="light" className="p-1 rounded-circle">
                                            <CiImport size={16} />
                                        </Button>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="light"
                                            className="p-1 rounded-circle without-arrow">
                                                <HiOutlineDotsCircleHorizontal size={20} />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item as="button">Option 1</Dropdown.Item>
                                                <Dropdown.Item as="button">Option 2</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </Card>
    </div>
    </> );
}
 
export default BillingSubscription;